import { render, staticRenderFns } from "./RewardsForm.vue?vue&type=template&id=4d750d29&"
import script from "./RewardsForm.vue?vue&type=script&lang=js&"
export * from "./RewardsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports